import { useHttpClient } from './httpClient.js';

const resource = 'sortition_profits';

export function getProfits() {
	return useHttpClient().get(`/${resource}`);
}

export function saveProfits(form) {
	return useHttpClient().post(`/${resource}`, form);
}
